import * as React from 'react';
import { StyledViews } from './Styles';
import { Icon } from '../Icon';
export var ViewsButton = function ViewsButton(props) {
  var viewCount = props.viewCount;

  if (!!viewCount && viewCount > 0) {
    return React.createElement(StyledViews, {
      title: props.tooltipText,
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      className: props.className || ''
    }, React.createElement(Icon, {
      iconUrl: "eye_icon.svg"
    }), Intl.NumberFormat().format(viewCount));
  }

  return null;
};